import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../../Core/Ctas';

export const Block = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.white')};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-row: 1 / -1;
    grid-template-rows: subgrid;
    border-radius: 0.625rem;
  }
`;

export const Heading = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
`;

export const Content = styled.div`
  padding: 0rem 2.25rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-row: 4 / 9;
    grid-template-rows: subgrid;
  }
`;

export const ImageWrapper = styled.div`
  display: grid;
  grid-row: 1 / 2;
  width: 100%;
  background-image: ${({ $image }) => `url(${$image})`};
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  height: calc(50vh / 2.5 - 0.75rem);
  max-height: 18.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    height: calc(50vh / 2 - 0.75rem);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 20vh;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 25vh;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    height: calc(50vh - 0.75rem);
  }
`;

export const LegalCopy = styled.p`
  text-align: center;
  font-size: 1.25rem;
  line-height: 150%;
  color: ${themeGet('colors.main-text')};
  font-weight: ${themeGet('fontWeights.medium')};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.5rem 2.25rem 0.25rem 2.25rem;
  text-align: ${({ $textAlignment }) => $textAlignment || 'left'};
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-row: 2 / 4;
    grid-template-rows: subgrid;
  }
`;

export const StyledCtas = styled(Ctas)`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 1.5rem;
    flex-direction: column;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    gap: 1.5rem;
    flex-direction: row;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-self: center;
  grid-row: 9 / 10;
  margin-bottom: 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    align-self: flex-end;
  }
`;

export const BodyCopy = styled.p`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;
